import React, { useState } from 'react';
import { Row, Col } from 'react-bootstrap5';
import Table from 'components/new_ui/Table';
import currencyFormat from 'components/Widgets/currencyFormat';
import { useContext } from 'components/Managers/Billing/Context';
import { useContext as useUsersContext } from 'components/Users/Context';
import Select from 'components/new_ui/Select';
import columns from './columns';

const generateFilter = (invoices) => {
  const options = [];

  invoices.forEach((item) => {
    if (!options.some((option) => option.value === item.attributes.payment_information_label)) {
      options.push({
        value: item.attributes.payment_information_label,
        label: item.attributes.payment_information_label,
      });
    }
  });

  return options;
};

export default function Index() {
  const { state } = useContext();
  const { state: stateUsers } = useUsersContext();

  const [paymentMethod, setPaymentMethod] = useState(null);

  const rowActions = [
    {
      title: 'View',
      type: 'CUSTOM',
      iconClass: 'file-icon',
      href: (row) => row.attributes.invoice_link,
    },
    {
      title: 'Download',
      type: 'CUSTOM',
      iconClass: 'download-icon',
      href: (row) => row.attributes.invoice_pdf,
    },
    {
      title: 'Download Members',
      type: 'CUSTOM',
      iconClass: 'download-icon',
      href: (row) => row.attributes.members_report,
    },
  ];

  const invoices = (state.policy?.attributes?.invoices || [])
    .filter((invoice) => paymentMethod === null || invoice.attributes.payment_information_label === paymentMethod);

  return (
    <section className="pt-2">
      <h4 className="mt-3">Invoice History</h4>
      {stateUsers.user && !stateUsers.user.attributes.specific.is_billing_manager && (
      <Row className="mt-3">
        <Col md={2} className="fw-light">Payment Method:</Col>
        <Col md={{ span: 4 }}>
          <Select
            id="policy-plan-payment-methods"
            placeholder={invoices ? 'Filter by Payment Method' : 'Payment Method Loading ...'}
            isClearable
            options={invoices
              ? generateFilter(invoices)
              : []}
            onChange={(selectedOption) => { setPaymentMethod(selectedOption ? selectedOption.value : null); }}
          />
        </Col>
      </Row>
      )}

      <Table
        columns={columns}
        data={invoices}
        loading={state.policy === null}
        selectableRows={false}
        rowActions={rowActions}
      />

      {invoices.length > 0
        && (
          <div className="mt-4 fs-4 text-end">
            Total:
            {' '}
            {currencyFormat(
              invoices.reduce((sum, item) => sum + item.attributes.amount, 0),
              { currency: invoices[0].attributes.currency.title },
            )}
          </div>
        )}
    </section>
  );
}
